
import React from 'react'
import { Navigate } from 'react-router-dom';
import { useSessionStore } from '../hooks/useSessionStore'

export const PrivateUsuarioAndNoRegitrado = ({ children }) => {
    /* Using the useSessionStore hook to get the user from the local storage. */
    const [Usuario, setUsuario] = useSessionStore({});


    /* Checking if the user is logged in or not. If the user is logged in, it will render the children. If
    the user is not logged in, it will redirect the user to the login page. */
    return (Usuario === undefined || Usuario.tipo === "usuarioNormal" || Usuario.tipo === "noRegistrado")
        ? children
        : (Usuario.tipo === "usuarioEmpresa")
            ? <Navigate to="/miEmpresa" />
            : (Usuario.tipo === "usuarioAdmin")
            && <Navigate to="/Usuarios" />
}
